import axiosPost from '../axiosPost';

export const tiposDeDomicilioDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "TipoDeDomicilioDel",
        "params": {
            "tipoDeDomicilioId": id
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}